import config from './config.json';
var getConfig = function (env) {
    return Object.assign({}, config[env] || config.default);
};
export default getConfig;
